import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface MessageDialogProps {
  selectedMessage: any;
  mockOwners: any[];
  mockProperties: any[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MessageDialog({ 
  selectedMessage, 
  mockOwners, 
  mockProperties, 
  open, 
  onOpenChange 
}: MessageDialogProps) {
  if (!selectedMessage) return null;

  const owner = mockOwners.find(o => o.id === selectedMessage.ownerId);
  const property = mockProperties.find(p => p.id === selectedMessage.propertyId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Detalhes do Agendamento</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <p className="text-sm font-medium text-gray-500">Proprietário</p>
            <p>{owner?.name}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Imóvel</p>
            <p>{property?.title}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Data e Hora</p>
            <p>
              {format(selectedMessage.nextDate, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Mensagem</p>
            <p className="whitespace-pre-wrap">{selectedMessage.message}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}